import React, { useEffect, useRef, type ReactElement } from 'react';

type AnimatedOnScrollProps = {
    BaseClass: string,
    AnimateClass: string,
    InnerHtml: ReactElement | null,
};

const AnimatedOnScroll: React.FC<AnimatedOnScrollProps> = ({ BaseClass, AnimateClass, InnerHtml }) => {
    let self = useRef(null);

    useEffect(() => {
        let selfObservable = self.current;
        if (!selfObservable) return;

        const intersectionCallback = (entries: any) => {
            for (const entry of entries) { // Loop over all elements that either enter or exit the view.
                if (entry.isIntersecting) { // This is true when the element is in view.
                    entry.target.classList.add(AnimateClass); // Add a class.
                }
            }
        }

        const observer = new IntersectionObserver(intersectionCallback);

        observer.observe(selfObservable);
    });

    if (InnerHtml == null) {
        return (
            <div ref={self} className={BaseClass} />
        );
    } else {
        return (
            <div ref={self} className={BaseClass}>
                {InnerHtml}
            </div>
        );
    }
};

export default AnimatedOnScroll;
